import { createContext, useContext, useState } from "react"

type TicketSelection = {
  id: number
  quantity: number
}[]

type TicketContextType = {
  ticketSelections: TicketSelection
  setTicketSelections: (selections: TicketSelection) => void
}

const TicketContext = createContext<TicketContextType | undefined>(undefined)

const TicketProvider = ({ children }: { children: React.ReactNode }) => {
  const [ticketSelections, setTicketSelections] = useState<TicketSelection>([])

  return (
    <TicketContext.Provider value={{ ticketSelections, setTicketSelections }}>
      {children}
    </TicketContext.Provider>
  )
}

const useTicketContext = () => {
  const context = useContext(TicketContext)
  if (context === undefined) {
    throw new Error("useTicketContext must be used within a TicketProvider")
  }
  return context
}

export { TicketProvider, useTicketContext }
